function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.01,
  fill: "#416DE0",
  d: "M0 0h20v20H0z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.125 13.547c0 .22-.102.419-.26.545-.124.451-.124 1.737 0 2.188.158.13.26.328.26.548v.469c0 .39-.313.703-.703.703h-9.61A2.813 2.813 0 013 15.187V5.813A2.813 2.813 0 015.813 3h9.609c.39 0 .703.313.703.703v9.844zm-9.2-6.797a.176.176 0 00-.175.176v.586c0 .096.08.176.176.176h6.21c.097 0 .177-.08.177-.176v-.586a.176.176 0 00-.176-.176H6.926zM6.75 8.8c0-.096.08-.175.176-.175h6.21c.097 0 .177.08.177.176v.586c0 .096-.08.175-.176.175H6.926a.176.176 0 01-.176-.175V8.8zm-.938 7.325h8.362a10.56 10.56 0 010-1.875H5.813a.936.936 0 100 1.875z",
  fill: "#416DE0"
});

var SvgBook = function SvgBook(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Crect opacity='0.01' width='20' height='20' fill='%23416DE0'/%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M16.125 13.5469C16.125 13.7666 16.0225 13.9658 15.8643 14.0918C15.7412 14.543 15.7412 15.8291 15.8643 16.2803C16.0225 16.4092 16.125 16.6084 16.125 16.8281V17.2969C16.125 17.6865 15.8115 18 15.4219 18H5.8125C4.25977 18 3 16.7402 3 15.1875V5.8125C3 4.25977 4.25977 3 5.8125 3H15.4219C15.8115 3 16.125 3.31348 16.125 3.70312V13.5469ZM6.92578 6.75C6.8291 6.75 6.75 6.8291 6.75 6.92578V7.51172C6.75 7.6084 6.8291 7.6875 6.92578 7.6875H13.1367C13.2334 7.6875 13.3125 7.6084 13.3125 7.51172V6.92578C13.3125 6.8291 13.2334 6.75 13.1367 6.75H6.92578ZM6.75 8.80078C6.75 8.7041 6.8291 8.625 6.92578 8.625H13.1367C13.2334 8.625 13.3125 8.7041 13.3125 8.80078V9.38672C13.3125 9.4834 13.2334 9.5625 13.1367 9.5625H6.92578C6.8291 9.5625 6.75 9.4834 6.75 9.38672V8.80078ZM5.8125 16.125H14.1738C14.1182 15.624 14.1182 14.751 14.1738 14.25H5.8125C5.29688 14.25 4.875 14.6719 4.875 15.1875C4.875 15.7061 5.29395 16.125 5.8125 16.125Z' fill='%23416DE0'/%3E %3C/svg%3E";
export { SvgBook as ReactComponent };